import { render, staticRenderFns } from "./RelationshipsEdit.vue?vue&type=template&id=26c068da&"
import script from "./RelationshipsEdit.vue?vue&type=script&lang=js&"
export * from "./RelationshipsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports